import React from 'react';
import styled from 'styled-components';

const TimelineSkeleton = () => {
    return (
        <Container>
            <ChartSkeleton />
        </Container>
    );
};

export default TimelineSkeleton;

const Container = styled.div`
    width: 100%;
    padding: 1.5rem;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
`;

const ChartSkeleton = styled.div`
    height: 350px;
    width: 100%;
    background: #f3f4f6;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    
    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.5) 20%,
            rgba(255, 255, 255, 0.8) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: shimmer 1.5s infinite;
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }
`;
